
<div class="fsBorder card" style="box-shadow: 0px 1px 16px #ddd;">
    <h4 class="text-muted"> Fare Summary </h4>
    <div *ngIf="showFlightDetails">
        <div class="col-md-12 col-lg-12 cardList rounded nopad">
            <div class="cardListBody mobile_nopad border_btm" style="padding: 15px; border-bottom:1px solid #ddd;"
                *ngFor="let iList of flight?.FlightDetails?.Details;let i = index">
                <div class="col-md-12 mobile_botpad" *ngFor="let f of iList;">
                    <div>
                        <div class="cellStyles">
                            <span class="bluecolor" style="font-weight: 600; margin-bottom: 3px; display: block;">
                                {{f.Origin.DateTime | date:'d MMM y, EEE'}}
                            </span>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-4 col-4 nopad">
                                    <img style="max-width: 95px; height: 40px;" class="rounded"
                                        [src]="[airline_logo + f.OperatorCode + '.svg']" alt="">
                                </div>
                                <div class="col-md-8 col-8 nopad" style="line-height: normal;">
                                    <span class="greay_color"
                                        style="font-size: 14px; display: block; line-height:50px;">
                                        {{f.OperatorName}} ({{f.DisplayOperatorCode}})</span>
                                    <small>{{f.CabinClass}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mobile_top">
                            <div class="row">
                                <div class="col-md-3 col-3 nopad" style="line-height: normal;">
                                    <span class="gray_color1" style="font-size: 16px;">{{f.Origin.DateTime | map:
                                        getTime}}</span>
                                    <br><small style="color:#C5C5C5">{{f.Origin.AirportCode}}</small>
                                </div>
                                <div class="col-md-2 col-1 nopad text-center"><span class="mt-2"
                                        style="display: block;"><i class="fal fa-exchange"></i></span></div>
                                <div class="col-md-3 col-3 nopad text-right" style="line-height: normal;">
                                    <span class="gray_color1" style="font-size:16px;">{{f.Destination.DateTime |
                                        map: getTime}}</span>
                                    <br><small style="color:#C5C5C5">{{f.Destination.AirportCode}}</small>
                                </div>
                                <div class="col-md-4 col-5 nopad text-right" style="line-height: normal;">
                                    <span class="gray_color1" style="font-size: 16px;">{{f.Duration}}</span>
                                    <br><small style="color:#C5C5C5">{{f.CabinClass}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cardListBody mobile_nopad border_btm" style="padding: 15px; border-bottom:1px solid #ddd;"
                *ngFor="let f of flight?.FlightItineraries;let i = index">
                <div>
                    <div class="cellStyles">
                        <span class="bluecolor" style="font-weight: 600; margin-bottom: 3px; display: block;">
                            {{f.departure_datetime_ios | date:'d MMM y, EEE'}}
                        </span>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4 col-3 nopad">
                                <img style="max-width: 75px; height: 40px;" class="rounded"
                                    [src]="[airline_logo + f.airline_code + '.svg']" alt="">
                            </div>
                            <div class="col-md-8 col-9 nopad" style="line-height: normal;">
                                <span class="greay_color"
                                    style="font-size: 14px; display: block; line-height:50px;">
                                    {{f.airline_name}} ({{f.airline_code}}) <small>{{f.fare_class}}</small></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mobile_top">
                        <div class="row">
                            <div class="col-md-3 col-3 nopad" style="line-height: normal;">
                                <span class="gray_color1" style="font-size: 16px;">{{f.departure_datetime_ios| map:
                                    getTime}}</span>
                                <br><small style="color:#C5C5C5">{{f.from_airport_code}}</small>
                            </div>
                            <div class="col-md-2 col-1 nopad text-center"><span class="mt-2"
                                    style="display: block;"><i class="fal fa-exchange"></i></span></div>
                            <div class="col-md-3 col-3 nopad text-right" style="line-height: normal;">
                                <span class="gray_color1" style="font-size:16px;">{{f.arrival_datetime_ios |
                                    map: getTime}}</span>
                                <br><small style="color:#C5C5C5">{{f.to_airport_code}}</small>
                            </div>
                            <div class="col-md-4 col-5 nopad text-right" style="line-height: normal;">
                                <span class="gray_color1" style="font-size: 16px;">Cabin Class</span>
                                <br><small style="color:#C5C5C5">{{f.fare_class}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-gradient-light px-0 pt-2 pb-3">
        <div>
            <div class="row m-0 text-muted">
                <ng-container *ngIf="isAdult(flight)">
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left">
                            <b>Adult Ticket</b>
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT?.TotalPrice |
                            number:'1.0-0' }} X {{
                            adultCount }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left customColor">
                            Base Fare
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }}
                            {{ flight.Price.PassengerBreakup.ADT?.BasePrice | number:'1.0-0' }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 bbottom mb-3">
                        <div class="float-left customColor">
                            Taxes &amp; Fees
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT?.Tax | number:'1.0-0'
                            }}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="isChild(flight)">
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left">
                            <b>Child Ticket</b>
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD?.TotalPrice |
                            number:'1.0-0' }} X {{
                            childCount }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left customColor">
                            Base Fare
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }}
                            {{ flight.Price.PassengerBreakup.CHD?.BasePrice | number:'1.0-0' }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 bbottom mb-3">
                        <div class="float-left customColor">
                            Taxes &amp; Fees
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD?.Tax | number:'1.0-0'
                            }}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="isInfant(flight)">
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left customColor">
                            <b>Infant Ticket</b>
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF?.TotalPrice |
                            number:'1.0-0' }} X {{
                            infantCount }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 mb-2">
                        <div class="float-left customColor">
                            Base Fare
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }}
                            {{ flight.Price.PassengerBreakup.INF?.BasePrice | number:'1.0-0' }}
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 f-14 bbottom mb-3">
                        <div class="float-left customColor">
                            Taxes &amp; Fees
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF?.Tax | number:'1.0-0'
                            }}
                        </div>
                    </div>
                </ng-container>
                <!-- <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="showFlightDetails" style="display:none">
                    <div class="float-left customColor">
                        Extra Baggage Fee
                    </div>
                    <div class="float-right customColor">
                        {{ flight?.Price && flight?.Price.Currency ? flight?.Price.Currency : 'INR' }} {{ baggageFee
                        }}
                    </div>
                </div> -->
                <!-- <div class="col-md-12 col-lg-12 f-14 bbottom mb-3" *ngIf="showFlightDetails" style="display:none">
                    <div class="float-left customColor">
                        Extra Meal Fee
                    </div>
                    <div class="float-right customColor">
                        {{ flight?.Price && flight?.Price.Currency ? flight?.Price.Currency : 'INR' }} {{ mealFee }}
                    </div>
                </div> -->
                <!-- <div class="col-md-12 col-lg-12 f-14 bbottom mb-3" *ngIf="showFlightDetails" style="display:none">
                    <div class="float-left customColor">
                        Seat Fee
                    </div>
                    <div class="float-right customColor">
                        {{ flight?.Price.Currency }} {{ seatFee | number:'1.0-0' }}
                    </div>
                </div> -->
                <div class="col-md-12 col-lg-12 f-14 mb-3"
                *ngIf="baggageFee">
                <div class="float-left" style="color: #082B3A !important;">
                    Extra Baggage
                </div>
                <div class="float-right customColor">
                    {{ flight?.Price.Currency }} {{ baggageFee | number:'1.2-2'  }}
                </div>
            </div>
            <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="mealFee">
                <div class="float-left" style="color: #082B3A !important;">
                    Extra Meal
                </div>
                <div class="float-right customColor">
                    {{ flight?.Price.Currency }} {{ mealFee | number:'1.2-2' }}
                </div>
            </div>
            <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="seatFee">
                <div class="float-left" style="color: #082B3A !important;">
                    Seat
                </div>
                <div class="float-right customColor">
                    {{ flight?.Price.Currency }} {{ seatFee | number:'1.2-2' }}
                </div>
            </div>
            <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="convenienceFee">
                <div class="float-left" style="color: #082B3A !important;">
                    Convenience Fee
                </div>
                <div class="float-right customColor">
                    {{ flight?.Price.Currency }} {{ flight?.Price.ConvinenceFee | number:'1.0-0' }}
                </div>
            </div>
                <div class="col-md-12 col-lg-12 f-14 bbottom mb-3"
                    *ngIf="flight?.Price?.PriceBreakup.TotalLostBaggageProtection">
                    <div class="float-left customColor">
                        Baggage Protection Fee
                    </div>
                    <div class="float-right customColor">
                        {{ flight?.Price.Currency }} {{ flight?.Price.PriceBreakup.TotalLostBaggageProtection |
                        number:'1.0-0' }}
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="promocode">
                    <div class="float-left" style="color: #082B3A !important;">
                        Discount
                    </div>
                    <div class="float-right customColor">
                        {{ flight?.Price.Currency}}  {{discount_value | number:'1.0-0'}}
                    </div>
                <!-- <div class="col-md-12 col-lg-12 f-14 mb-3" *ngIf="flight?.Price?.PriceBreakup.AdvanceTax">
                    <div class="float-left" style="color: #082B3A !important;">
                        AIT
                    </div>
                    <div class="float-right customColor">
                        {{ flight.Price.Currency }} {{ flight.Price.PriceBreakup.AdvanceTax | number:'1.0-0' }}
                    </div> -->
                     
                </div> 
                <ng-container *ngIf="!convenienceFee">
                    <div class="col-md-12 col-lg-12 f-18 mb-3">
                        <div class="float-left text-uppercase grand_tot">
                            Grand Total
                        </div>
                        <div *ngIf="!showTotalDisplayFare" class="float-right text-warning" style="color:#FF9800 !important;">
                            {{ flight?.Price?.Currency }} {{ totalDisplayFare - discount_value| number:'1.0-0' }}
                        </div>
                        <div *ngIf="showTotalDisplayFare" class="float-right text-warning" style="color:#FF9800 !important;">
                            {{ flight?.Price?.Currency }} {{ flight?.Price?.TotalDisplayFare - discount_value| number:'1.0-0' }}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="convenienceFee">
                    <div class="col-md-12 col-lg-12 f-18 mb-3">
                        <div class="float-left text-uppercase grand_tot">
                            Grand Total
                        </div>
                        <div *ngIf="!showTotalDisplayFare" class="float-right text-warning" style="color:#FF9800 !important;">
                            {{ flight?.Price?.Currency }} {{ totalDisplayFare + flight?.Price.ConvinenceFee - discount_value | number:'1.0-0' }}
                        </div>
                        <div *ngIf="showTotalDisplayFare" class="float-right text-warning" style="color:#FF9800 !important;">
                            {{ flight?.Price?.Currency }} {{ flight?.Price?.TotalDisplayFare + flight?.Price.ConvinenceFee - discount_value | number:'1.0-0' }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
